import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BASE_URL from "../constent";
import { getCurrencySymbol } from "../../constent/currencyUtils";
// Change currencies
export const changeCurrencyIso = createAsyncThunk(
  "currencies/changeIso",
  async (currencyCode, thunkAPI) => {
    try {
      const token = localStorage.getItem("accessToken");
      // console.log(token)
      const iso = localStorage.getItem("currency") || "KWD";
      const name = getCurrencySymbol(iso);
      const response = await axios.put(
        `${BASE_URL}/myData/changeIso`,
        {
          Iso: currencyCode,
          IsoName: {
            ar: name.ar,
            en: name.en,
          },
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Slice
const currenciesSlice = createSlice({
  name: "currencies",
  initialState: {
    currencies: [],
    loading: false,
    error: null,
  },
  reducers: {
    // Reducer to clear the error
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(changeCurrencyIso.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(changeCurrencyIso.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(changeCurrencyIso.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export the clearError action
export const { clearError } = currenciesSlice.actions;

// Export the reducer
export default currenciesSlice.reducer;
